/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * https://wiki.shop-apotheke.com/pages/viewpage.action?pageId=243880971 represents the reason set on a \"belgian RX by principle product\". Depending on reason set, different reasons, will be presented to be chosen from by customer when he attempts to buy a \"belgian RX by principle product\"
 */
export const RxByPrincipleReasonSet = {
    PseudoEfedrine: 'PSEUDO_EFEDRINE',
    Dextromethorfan: 'DEXTROMETHORFAN',
    Paracetamol: 'PARACETAMOL',
    ParacetamolPseudoEfedrine: 'PARACETAMOL_PSEUDO_EFEDRINE',
    ParacetamolIbuprofen: 'PARACETAMOL_IBUPROFEN'
};
